<template>
  <v-card
    v-if="!isDesktop || isSimulation"
    class="mx-auto"
    style="margin-bottom:15px;text-decoration: none !important;"
    :style="{
      'font-family': FontContent,
    }"
  >
    <v-img
      :style="{ 'width': isSimulation ? '345px' : '100%' }"
      :src="image"
    />
    <div
      :style="{ 'background-color': BGColorSecundary,
        'font-family': FontContent,
      }"
      style="padding-left: 15px;color: white;font-size:30px;"
    >
      {{ data.price}}
    </div>
    <v-card-text>
      <p 
        :style="{ 'color': BGColorSecundary }"
        style="font-size:22px;"
      >
      {{ data.title }}
      </p>
      <p 
        style="color: #CCCCCC;font-size:18px;"
      >
      {{ data.reference }}
      </p>
      <v-divider style="margin-bottom: 15px;"/>
      <table width="100%">
        <tr
          v-for="(item, index) in data.h4Data"
          :key="`h4${index}`"
          style="height:50px;"
        >
          <td>
            <v-img 
              style="width: 30px;height:auto;"
              :src="`../img/icons/${item.icon}.png`"
            /> 
          </td>
          <td
            style="valign:middle !important;"
            width="auto"
          >
            {{item.data}}
          </td>
          <td style="width: 50px;">
            <!-- <v-btn class="mx-2" fab dark small color="#cccccc">
              
            </v-btn> -->
            <v-icon v-if="index === 0" :color="BGColorSecundary" style="font-size:50px;"
              @click="handleGoToProperty"
            >mdi-information</v-icon>
          </td>
        </tr>
      </table>
      <v-btn
        color="#CCCCCC"
        block
        style="color: white;text-transform: capitalize;"
        @click.stop.prevent="handleGoToPhone(data.phoneInfo.trim())"
      >
        <v-icon style="margin-right: 10px;">mdi-phone</v-icon> <span style="font-size:16px;">{{data.agentDetails[0]}}</span> - {{data.phoneInfo.trim()}}
      </v-btn>
    </v-card-text>
  </v-card>

  <v-card
    v-else
    class="mx-auto"
    style="margin-bottom:15px;text-decoration: none !important;"
    :style="{
        'font-family': FontContent,
      }"
  >
   <v-layout
      text-left
      wrap
    >
      <v-flex
        xs6
      >
        <v-img
          :style="{ 'width': isSimulation ? '345px' : '100%' }"
          :src="image"
          style="border-radius: 5px 0 0 5px"
        />
      </v-flex>
      <v-flex
        xs6
      >
        <div
          :style="{ 'background-color': BGColorSecundary,
            'font-family': FontContent,
          }"
          style="text-align:right;padding-right: 15px;color: white;font-size:30px;border-radius: 0 5px 0 0"
        >
          {{ data.price}}
        </div>
        <v-card-text>
          <p 
            :style="{ 'color': BGColorSecundary }"
            style="font-size:22px;"
          >
          {{ data.title }}
          </p>
          <p 
            style="color: #CCCCCC;font-size:18px;"
          >
          {{ data.reference }}
          </p>
          <v-divider style="margin-bottom: 20px;"/>
          <v-layout
          >
            <v-flex
              xs6
            >
              <table width="100%">
                <tr
                  v-for="(item, index) in data.h4Data"
                  :key="`h4${index}`"
                  style="height:50px;"
                >
                  <td>
                    <v-img 
                      style="width: 30px;height:auto;"
                      :src="`../img/icons/${item.icon}.png`"
                    /> 
                  </td>
                  <td
                    style="valign:middle !important;"
                    width="auto"
                  >
                    {{item.data}}
                  </td>
                  <td style="width: 50px;">
                    <!-- <v-btn class="mx-2" fab dark small color="#cccccc">
                      
                    </v-btn> -->
                    <v-icon v-if="index === 0 && !isPI" :color="BGColorSecundary" style="font-size:50px;"
                      @click="handleGoToProperty"
                    >mdi-information</v-icon>
                  </td>
                </tr>
              </table>
            </v-flex>
            <v-flex
              xs6
            >
              <v-layout
                wrap
              >
                <v-flex
                  xs12
                  text-center
                >
                  <center>
                    <v-img
                      :src="data.avatar"
                      style="width:100px; height:auto; border-radius:50%;border: 1px solid #ccc;"
                    />
                  </center>
                </v-flex>
                <v-flex
                  xs12
                  :style="{ 
                    'color': BGColorSecundary,
                    'font-family': FontContent,
                  }"
                  style="font-size:22px;"
                >
                  <center>
                    <span style="font-size:16px;">{{data.agentDetails[0]}}</span>
                  </center>
                </v-flex>
                <v-flex
                  xs12
                  :style="{
                    'font-family': FontContent,   
                  }"
                  style="font-size:16px;"
                >
                  <center>
                    {{data.phoneInfo.trim()}}
                  </center>
                </v-flex>
              </v-layout>     
            </v-flex>
          </v-layout>     
          <v-btn
            v-if="!isPI"
            color="#CCCCCC"
            block
            style="color: white;text-transform: capitalize;"
            @click.stop.prevent="handleGoToPhone(data.phoneInfo.trim())"
          >
            <v-icon style="margin-right: 10px;">mdi-phone</v-icon> <span style="font-size:16px;">{{data.agentDetails[0]}}</span> - {{data.phoneInfo.trim()}}
          </v-btn>          
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    components: {
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
      url: {
        type: String,
        required: false,
        default: null,
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'BGColorSecundary', 'BGColorContent', 'BGColor', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile();
      },
      isPI () {
        if (this.$route.query.PI) return true
        return false
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      expandMenuID () {
        return this.$store.state.app.expandMenuID
      },
      image () {
        return this.data.images[0].replace('width=60&height=60', 'width=800&height=600')//.split('?')[0]
      }
    },
    mounted () {
    },
    methods: {
      getImage (icon) {
        return `../img/icons/${icon}.php`
      },
      handleGoToProperty () {
        window.open(
          this.url,
          '_blank' // <- This is what makes it open in a new window.
        )
      },
      handleGoToPhone (phone) {
        window.location.href = `tel:${phone}`
      }
    }
  }
</script>
<style scoped>
  a:link {
    text-decoration: none !important;
  }

  a:visited {
    text-decoration: none !important;
  }

  a:hover {
    text-decoration: none !important;
  }

  a:active {
    text-decoration: none !important;
  }
</style>
